import {
  // Game
  geeka,
  micro_hunt,
  ror,

  // Game System
  ladder_system,
  locomotion_system,
  map_system,
  pedestrian_ai_system,
  rts_camera_manager,
  save_game_system,
  ultimate_motion_system,
  weather_system,

  // Game Templates
  rts_template,

  // Models 3D
  low_poly_farming_environment,
} from "src/assets";

export const GAMES = [
  {
    title: "Rise of Rage",
    image: ror,
    engine: "Unreal Engine",
    platform: "Windows",
    category: "Multiplayer",
    link: "https://www.elsewaregames.com/games/rise-of-rage",
    description:
      "Rise of Rage is a team-based online multiplayer game with various game modes like FreeForAll, 1vs1, and Team Deathmatch. Compete on multiple maps with unique in-game characters.",
  },
  {
    title: "Micro Hunt",
    image: micro_hunt,
    engine: "Unity",
    platform: "Android",
    category: "Classic",
    link: "https://www.elsewaregames.com/games/micro-hunt",
    description:
      "Micro Hunt is a battle against invading Micros. Defeat 6 boss Micros, including the ultimate enemy, The Micro Alpha. Fight for survival and win the war!",
  },
  {
    title: "Geeka",
    image: geeka,
    engine: "Unity",
    platform: "Android",
    category: "Classic",
    link: "https://www.elsewaregames.com/games/geeka",
    description:
      "Help Geeka, a lost Golden Bird, find his way home after being caught in a storm. Navigate through challenges and guide him back to safety!",
  },
];

export const GAME_SYSTEMS = [
    {
      title: "Ultimate Motion System",
      description:
        "Redefine player movement with the Ultimate Motion System. Designed for seamless integration into Unreal Engine, this system delivers advanced locomotion mechanics, precise ladder interactions, and smooth vehicle controls—empowering developers to create dynamic, immersive experiences.",
      link: "https://www.elsewaregames.com/products/ultimate-motion-system",
      image: ultimate_motion_system,
      engine: "Unreal Engine",
      platform: "Windows",
    },
    {
      title: "Weather System",
      description:
        "Immerse players in dynamic environments with the Weather System. This advanced Unreal Engine tool simulates realistic weather conditions, from clear skies to storms, seamlessly adapting to time-of-day and gameplay scenarios to enhance immersion and realism.",
      link: "https://www.elsewaregames.com/products/weather-system",
      image: weather_system,
      engine: "Unreal Engine",
      platform: "Windows",
    },
    {
      title: "Locomotion System",
      description:
        "Achieve fluid and natural character movement with the Locomotion System. Built for precision and versatility, this system provides responsive animations and seamless transitions, making it ideal for action, RPG, and open-world games.",
      link: "https://www.elsewaregames.com/products/locomotion-system",
      image: locomotion_system,
      engine: "Unreal Engine",
      platform: "Windows",
    },
    {
      title: "Save Game System",
      description:
        "Ensure seamless player progression with the Save Game System. This robust solution enables efficient game state management, supporting auto-save, manual save slots, and cloud integration—providing a reliable foundation for RPGs, simulations, and narrative-driven games.",
      link: "https://www.elsewaregames.com/products/save-game-system",
      image: save_game_system,
      engine: "Unreal Engine",
      platform: "Windows",
    },
    {
      title: "Pedestrian AI System",
      description:
        "Bring urban environments to life with the Pedestrian AI System. This advanced framework enables realistic NPC pathfinding, behaviors, and interactions, making it essential for open-world cities, simulations, and AI-driven worlds.",
      link: "https://www.elsewaregames.com/products/pedestrian-ai-system",
      image: pedestrian_ai_system,
      engine: "Unreal Engine",
      platform: "Windows",
    },
    {
      title: "RTS Camera Manager",
      description:
        "Enhance strategic gameplay with the RTS Camera Manager. Featuring intuitive controls, multi-angle perspectives, and seamless zooming, this system offers a refined camera experience tailored for real-time strategy, simulation, and city-building games.",
      link: "https://www.elsewaregames.com/products/rts-camera-manager",
      image: rts_camera_manager,
      engine: "Unreal Engine",
      platform: "Windows",
    },
    {
      title: "Ladder System",
      description:
        "Expand vertical traversal with the Ladder System. Designed for smooth character interaction, this system ensures precise animations and physics-driven movement, making climbing feel natural and responsive in any game environment.",
      link: "https://www.elsewaregames.com/products/ladder-system",
      image: ladder_system,
      engine: "Unreal Engine",
      platform: "Windows",
    },
    {
      title: "Map System",
      description:
        "Optimize world navigation with the Map System. Featuring customizable markers, zoom levels, and dynamic updates, this system provides players with an intuitive way to explore, strategize, and engage with open-world and tactical environments.",
      link: "https://www.elsewaregames.com/products/map-system",
      image: map_system,
      engine: "Unreal Engine",
      platform: "Windows",
    },
  ];

export const GAME_TEMPLATES = [
  {
    title: "RTS Template",
    description:
      "Create immersive real-time strategy games with our RTS Template. This comprehensive and versatile asset provides a solid foundation for RTS game development, enabling resource management, strategic battles, and empire-building mechanics.",
    link: "https://www.elsewaregames.com/products/real-time-strategy-(rts)-game-template",
    image: rts_template,
    engine: "Unreal Engine",
    platform: "Windows",
  },
];

export const MODELS_3D = [
  {
    title: "Low Poly Farming Environment",
    description:
      "Create vibrant and stylized farming landscapes with the Low Poly Farming Environment. This asset pack provides an optimized and visually appealing environment for games on PC, console, and mobile. With a diverse collection of handcrafted assets, you can effortlessly build immersive farming scenes in Unreal Engine, Unity, and Godot.",
    link: "https://www.elsewaregames.com/products/low-poly-farming-environment",
    image: low_poly_farming_environment,
    engine: "Unreal Engine, Unity, Godot",
  },
];
